import script from "./PersonProfileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonProfileTab.vue?vue&type=script&setup=true&lang=js"

import "./PersonProfileTab.vue?vue&type=style&index=0&id=69f6f28a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69f6f28a"]])

export default __exports__